import React, { Fragment, useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import blogImage from './blogcover.png'; 
import BlogDetailPage1 from "./blogdetail1";
import blogImage4 from './blog4.png'; 
import BlogDetailPage2 from "./blogdetail2";

function Blogs() {
  const [selectedBlog, setSelectedBlog] = useState(null);
  console.log('selectedBlog: 2222222', selectedBlog);
  const blogs = [
    {
      id: 1,
      title: 'Top 10 Business Ideas in Rural India That Need a Website in 2025',
      description: 'In 2025, Digital India is not just a slogan. Its a ground-level reality. Villages are no longer cut off from the digital world. With cheaper smartphones and affordable internet, even the most remote areas are now connected. From watching YouTube to sending payments through UPI, rural India is going online. Sab kuch ab gaon tak pahuch gaya hai!',
      imageUrl: blogImage
    },
    {
      id: 2,
      title: '10 Must‑Have Features for Your Small Business Website in 2025',
      description: 'In today’s digital age, your website is not just an online brochure. It’s your digital identity, your storefront, and often your first impression. For small busin',
      imageUrl: blogImage4
    },
    {
      id: 3,
      title: 'Blog Title 3',
      description: 'Nullam eu arcu sit amet turpis sagittis ullamcorper ut eget mi...',
      imageUrl: 'https://images.unsplash.com/photo-1644088379091-d574269d422f?q=80&w=1993&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    },
    {
      id: 4,
      title: 'Blog Title 4',
      description: 'Phasellus sit amet velit aliquam, consequat mi molestie, placerat arcu...',
      imageUrl: 'https://images.unsplash.com/photo-1423784346385-c1d4dac9893a?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    },
    {
      id: 5,
      title: 'Blog Title 5',
      description: 'Mauris sit amet ipsum tortor. Nullam eu arcu sit amet turpis sagittis...',
      imageUrl: 'https://images.unsplash.com/photo-1733506260469-8a6a07d95051?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    },
    {
      id: 6,
      title: 'Blog Title 6',
      description: 'Vivamus non gravida est. Vivamus et lacus tellus...',
      imageUrl: 'https://images.unsplash.com/photo-1699783080660-bda9256889fa?q=80&w=1964&auto=format&fit=crop'
    }
  ];

  const handleBlogClick = (blogId) => setSelectedBlog(blogId);
  const handleBackClick = () => setSelectedBlog(null);

  return (
    <Fragment>
      <div className="services-section text-center mt-5">
        <h2 className="animate__animated animate__fadeInDown" style={{ fontFamily: 'Quicksand', fontWeight: 700 }}>
          Explore Our Blogs
        </h2>
        <p style={{ fontSize: 16, fontWeight: 500, maxWidth: 700, margin: '20px auto', color: '#444' }}>
          Dive into insights on innovation, tech trends, and digital growth strategies curated by MyDigitalIndia.
        </p>
      </div>

      <Container style={{ margin: '3rem auto' }}>
        {selectedBlog === 1 ? (
          <BlogDetailPage1 blog={selectedBlog} onBack={handleBackClick} />
        ) : selectedBlog === 2 ? (
          <BlogDetailPage2 blog={selectedBlog} onBack={handleBackClick} />
        )
         : (
          <Row>
            {blogs.map((blog) => (
              <Col key={blog.id} md={6} lg={4} className="mb-4">
                <Card
                  style={{
                    borderRadius: '10px',
                    overflow: 'hidden',
                    background: '#fff',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={blog.imageUrl}
                    alt={blog.title}
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <Card.Body>
                    <Card.Title style={{ fontWeight: '500', fontSize: 17 }}>{blog.title.substring(0, 40)}...</Card.Title>
                    <Card.Text style={{ color: '#555' }}>
                      {blog.description.substring(0, 50)}...
                    </Card.Text>
                    <Button
                      variant="primary"
                      onClick={() => handleBlogClick(blog.id)}
                      style={{
                        backgroundColor: '#eee',          // ✅ use camelCase
                        color: '#222222',
                        borderRadius: '50px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: 500,                  // ✅ remove !important, not valid here
                        padding: '5px 16px',
                        whiteSpace: 'nowrap',
                        userSelect: 'none',
                        transition: 'background-color 0.3s ease',
                        width: 'auto'
                      }}
                    >
                      Read More
                    </Button>

                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </Fragment>
  );
}

export default Blogs;
